module.exports = __webpack_public_path__ + "img/fulanito.18cb5f44.jpg";